import React, {useState} from 'react'
import styles from '../css/DemotionReason.module.css'
import Icon from '../../Icon/Icon'

function DemotionReason(props) {
    const [remove, setRemove] = useState(false)
    const icon = remove ? <span aria-hidden="true">↩</span> : <Icon name="trash" />

    return (
        <div className={[styles.wrapper, remove ? styles.remove : ''].join(' ')} style={{ height: 'auto', alignItems: 'center', paddingTop: 4, paddingBottom: 4 }}>
            <div style={{ display: 'flex', flex: 1, gap: 6, alignItems: 'center' }}>
                <input
                    className={[styles.input, remove ? styles.remove : ''].join(' ')}
                    value={props.data.reason}
                    placeholder="Reason"
                    disabled={remove}
                    maxLength={300}
                    style={{ flex: 1 }}
                    onChange={(e) => props.changeReason('reason', e.target.value, props.index)}
                />
            </div>
            <div className={styles.icon} onClick={() => {
                setRemove(!remove)
                props.deleteReason(props.index, remove)
            }}>
                {icon}
            </div>
        </div>
    )
}

export default DemotionReason
